import React from 'react';
import { ButtonLink, Heading2 } from '@blueprint/ui';
import { trackValuationCTA } from './ListingValuation.tracking';
import { ListingValuationContainer } from './ListingValuation.styles';

const ListingValuation = () => {
    return (
        <ListingValuationContainer aria-labelledby="listing-valuation-heading">
            <Heading2 id="listing-valuation-heading" size="8" isRegular>
                Want an expert valuation of your home?
            </Heading2>
            <ButtonLink
                href="/valuation/"
                onClick={trackValuationCTA}
                variant="secondary"
                isFullWidth
                data-testid="listing-valuation-cta"
            >
                Book an agent valuation
            </ButtonLink>
        </ListingValuationContainer>
    );
};

export default ListingValuation;
